<template>
  <div v-if="p" :key="p.id_pedido"
       class="kanban-item text-dark" draggable tabindex="0" @dragstart="startDrag($event, p.id_pedido)"
       @click="$emit('abrirPedido', p)" @keyup.enter="$emit('abrirPedido', p)">
    <div class="kanban-item-header" v-if="nome">{{ p.nome_fantasia }}</div>
    <div class="kanban-item-body">
      <div class="row no-gutters" style="margin-bottom: 5px">
        <div class="col-9 pr-2">
          <span v-if="p.impresso" :title="`Impresso: ${formatarData(p.impresso)}`" class="badge badge-secondary mr-1"><i class="fa fa-print"></i></span>
          <span class="badge badge-success" title="Este pedido deverá ser entregue ao cliente" v-if="p.tipo_pedido === '1'">Entregar</span>
          <span class="badge badge-primary" title="Este pedido será retirado no estabelecimento" v-else-if="p.tipo_pedido === '2'">Retirar</span>
          <span class="badge badge-warning" title="Este pedido será consumido no estabelecimento" v-else>Consumir</span>
          <a href="javascript:" class="badge border border-success text-success ml-1"
             v-if="p.id_entregador" @click.stop="$emit('escolherEntregador', p)" :title="`Entregador: ${p.nome_entregador}`">
            <img src="../../assets/icons/helmet.svg" class="mr-1"><b>{{p.nome_entregador | max }}</b>
          </a>
          <a href="javascript:" title="Adicionar entregador" class="text-success small ml-2 text-nowrap" @click.stop="$emit('escolherEntregador', p)"
             v-if="!p.id_entregador && p.tipo_pedido === '1' && p.status !== '1' && p.status < 5">
            <i class="fa fa-plus mr-1"></i> Entregador
          </a>
        </div>
        <div class="col-3 text-right">
          <div>
            <img src="../../assets/icons/ifood.svg" class="mt-1" title="Pedido realizado via iFood" style="width: 30px" v-if="p.origin === '6'">
            <img src="../../assets/icons/uairango.svg" title="Pedido realizado via UaiRango" class="mt-2" style="width: 30px" v-else-if="p.origin === '7'">
            <img v-else-if="p.origin === '9'" class="mt-2" src="../../assets/icons/keeta.png" style="width: 30px" title="Pedido realizado via Keeta">
            <img v-else-if="p.origin === '10'" class="mt-2" src="../../assets/icons/aiqfome.svg" style="width: 30px" title="Pedido realizado via AiQFome">
            <img v-else-if="p.origin === '11'" src="../../assets/icons/99food.png" style="width: 30px" title="Pedido realizado via 99Food">
            <span class="badge border border-dark" title="Pedido realizado no App ou Site" v-else-if="p.origin === '1'">App/Site</span>
            <span class="badge border border-dark" title="Pedido realizado via App LeCard" v-else-if="p.origin === '2'">Geral</span>
            <span class="badge border border-dark" title="Pedido realizado via Pedido Manual" v-else-if="p.origin === '3'">Manual</span>
            <span class="badge border border-dark" title="Pedido realizado via Qr Code no local" v-else-if="p.origin === '4'">Qr Code</span>
            <span class="badge border border-dark" title="Pedido realizado via Tablet" v-else-if="p.origin === '8'">Tablet</span>
            <span v-else-if="p.origin === '5'" class="badge badge-success px-2" title="Pedido realizado via WhatsApp"><span class="icon-whatsapp"></span></span>
          </div>
        </div>
      </div>
      <div>
        <h6 class="mb-0 text-ellipsis" :title="p.nome_cliente" style="max-width: 100%">
          <b>#{{p.id_contador}}</b> - {{ p.nome_cliente }}
        </h6>
        <div class="small" v-if="p.data_agendamento && p.status < 4">
          <span :title="`Data do pedido: ${formatarData(p.data_pedido)}`" class="badge bg-secondary text-white">AGENDADO</span><span class="mx-1">|</span>
          <span title="Data do agendamento"><img class="icon-previsao" src="../../assets/icons/calendar.svg"> {{ p.data_agendamento | fDate }}</span>
        </div>
        <div class="small" v-else>
          <span title="Data que o pedido foi realizado">{{p.data_pedido | fDate}}</span><span class="mx-1">|</span>
          <span v-if="p.previsao" :title="`Previsão: ${this.formatarData(p.previsao)}`">
            <span v-if="p.status !== '2'"><img class="icon-previsao" src="../../assets/icons/clock.svg"> {{ p.previsao | pMin }}</span>
            <span v-else-if="previsao <= 0" class="badge badge-atrasado"><i class="fa fa-exclamation-triangle mr-1"></i>ATRASADO{{ fPrevisao(p.previsao) }}</span>
            <span v-else-if="previsao > 0 && previsao < 12" class="badge badge-atencao"><i class="fa fa-bolt mr-1"></i>PREVISÃO{{ fPrevisao(p.previsao) }}</span>
            <span v-else class="badge badge-normal"><i class="fa fa-clock mr-1"></i>PREVISÃO{{ fPrevisao(p.previsao) }}</span>
          </span>
        </div>
        <div class="small border px-1 rounded my-1 text-center" v-if="p.origin === '4' || p.tipo_pedido === '3'">
          <div v-if="p.tipo_pedido === '2'"><i class="fa fa-car-side text-warning mr-1"></i> Para levar: {{p.nolocal}}</div>
          <div v-else><i class="fa fa-utensils text-warning mr-1"></i> Consumo local: {{p.nolocal}}</div>
        </div>
        <div class="small border px-1 rounded my-1 text-center text-ellipsis" v-else-if="p.tipo_pedido === '1'">
          <i class="fa fa-map-marker-alt text-success mr-1"></i>
          <span>{{ p.obs_entrega | bairro }}</span>
        </div>
        <div class="small border px-1 rounded my-1 text-center" v-else>
          <i class="fa fa-walking text-primary mr-1"></i>
          Retirar no Local
        </div>
      </div>
      <div v-if="p.status < 4 && !emLote" style="margin-top: 7px">
        <button class="btn btn-success btn-block" @click.stop="$emit('acaoPedido', p, 2)" v-if="p.status === '1'" :disabled="load">{{ load === p.id_pedido ? 'Aguarde..' : 'Aceitar' }}</button>
        <button v-if="p.status === '2'" :disabled="load" class="btn btn-info btn-block" @click.stop="$emit('escolherEntregador', p, true)">{{ load === p.id_pedido ? 'Aguarde..' : 'Despachar Pedido' }}</button>
        <button class="btn btn-dark btn-block" @click.stop="$emit('finalizar', p)" v-if="p.status === '3'" :disabled="load">
          {{ load === p.id_pedido ? 'Aguarde..' : `Finalizar ${ p.id_comanda && p.origin !== '4' ? 'Venda' : 'Pedido' }` }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['p', 'entregadores', 'load', 'nome', 'emLote', 'agora'],
  name: "KanbanItem",

  methods: {
    startDrag(evt, id_pedido) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('id_pedido', id_pedido);
    },

    fPrevisao() {
      if (this.agora && this.p?.previsao) {
        const entrega = this.$dayjs(this.p.previsao);
        const minutes = Math.abs(entrega.diff(this.agora, 'minute'));
        const horas = Math.floor(minutes / 60);

        if (horas || minutes) {
          return (horas > 0) ? `: ${horas}h${String(minutes % 60).padStart(2,'0')}` : `: ${minutes}min`
        }
      }

      return '';
    }
  },

  computed: {
    previsao() {
      return (this.agora && this.p?.previsao) ? this.$dayjs(this.p.previsao).diff(this.agora, 'minute') : false;
    }
  },

  filters: {
    max(text) {
      return text && text.length > 12 ? text.slice(0 , 12) + '...' : text;
    },

    bairro(text) {
      let end = text ? text.split('$|') : null;
      return end && end.length > 1 ? end[1] : 'Abra para visualizar o endereço';
    },

    pMin(previsao) {
      return previsao.slice(11, 16);
    }
  }
}
</script>

<style scoped>
.kanban-item {
  margin: 8px 8px 4px;
  border-radius: 8px;
  background-color: #f8f9fa;
  cursor: pointer;
  box-shadow: 0 1px 1px #091E4240, 0 0 1px #091E424F;
  overflow: hidden;
}

.kanban-item-header {
  font-weight: bold;
  font-size: 0.8rem;
  border-bottom: 1px solid #e3e6f0;
  text-align: center;
  padding: 0 12px;
}

.kanban-item-body {
  padding: 4px 8px 8px;
}

.icon-previsao {
  margin: 0 0 2px;
}

.badge {
  padding-right: 6px;
  padding-left: 6px;
}

.badge.badge-normal {
  border: 1px solid var(--dark);
  position: relative;
}

.badge.badge-atrasado {
  position: relative;
  animation: pulseBorder 1.5s infinite;
  border: 1px solid var(--secondary);
  background-color: var(--secondary);
  color: #FFFFFF;
}

.badge.badge-atencao {
  position: relative;
  animation: pulseBorder 1.5s infinite;
  border: 1px solid #FFC300;
  color: #B8860B;
}

@keyframes pulseBorder {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.5);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
</style>
